module.exports = __webpack_public_path__ + "static/media/harpertruman.eb63a856.jpg";